<template>
  <div class="main win">
    <div class="header center">
      <img class="hero" src="@/assets/img/win.svg" alt="Win Virus" />

      <div class="title">
        <h1>YOU SAVED THE WORLD!</h1>
        <span
          >At <span class="bold">{{ $store.state.finalDate }}</span> the virus
          was defeated!</span
        >
      </div>
    </div>
    <div class="content">
      <div class="text fontMono">
        <div class="sub center">
          <div class="icon center">
            <img src="@/assets/img/final-pop.svg" alt="Population" />
          </div>
          <p>You saved {{ fPop }} lives!</p>
        </div>

        <div class="sub center">
          <div class="icon center">
            <img src="@/assets/img/pop-dead.svg" alt="Dead" />
          </div>
          <p>{{ fDead }} died</p>
        </div>

        <span
          >Scientists created a time machine and sent you back in the time to
          minimize the harm that the virus caused to humanity. <br /><br />
          All money you earned were send as well <b>{{ fMoney }}</b></span
        >
      </div>
    </div>
    <!-- <div class="spacer"></div> -->
    <transition name="fade">
      <a class="button" to="/game" @click="restart" v-if="showButton"
        >I can do better!</a
      >
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showButton: false,
    };
  },
  computed: {
    fMoney: function() {
      return this.$store.state.money
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    fDead: function() {
      return this.$store.state.dead
        .toFixed(0)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    fPop: function() {
      return this.$store.state.population
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },

  mounted: function() {
    if (this.$store.state.gameOver) {
      setTimeout(() => {
        this.showButton = true;
      }, 2000);
    } else {
      this.$router.push("/");
    }
  },

  methods: {
    restart: function() {
      this.track("level_start", "viruzz 02 win");
      this.$store.commit("resetGame");
      this.$router.push("/game");
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/index.scss";
.win {
  display: flex;
  flex-direction: column;
  margin: 0;
  background: $gray100;

  .header {
    background: $blue;
    padding-bottom: 60px;

    .hero {
      margin: 16px 0;
      min-width: 175px;
    }

    .title {
      text-align: center;
      margin-bottom: 16px;
      h1 {
        color: $yellow;
        margin-bottom: 8px;
      }
      span {
        color: #fff;
      }
    }
  }
  .content {
    .text {
      background: #fff;
      padding: 16px;
      border-radius: 12px;
      margin: -40px 16px 16px 16px;
      border: 1px solid $gray300;
      .sub {
        display: flex;
        flex-direction: row;
        margin-bottom: 16px;
        justify-content: flex-start;

        p {
          margin: 0;
          font-weight: bold;
        }

        .icon {
          padding: 4px;
          background: $gray100;
          border-radius: 4px;
          margin-right: 8px;

          img {
            max-width: 16px;
          }
        }
      }
    }
  }

  .button {
    margin: 16px;
  }
}
</style>
